import * as React from 'react';

function PdfTemplateIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={69} height={76} viewBox="0 0 69 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_4287_64304)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4239 0.329409C15.1132 0.64013 15.0849 2.95511 15.1349 24.0464C15.1875 46.3273 15.2083 47.4302 15.5832 47.6599C15.8978 47.8529 16.0384 47.8168 16.2894 47.4791C16.5573 47.118 16.6025 43.7757 16.6025 24.2837V1.50993H26.7735C35.2907 1.50993 37.013 1.45909 37.3663 1.19682C37.7039 0.946071 37.74 0.805268 37.5471 0.490636C37.3206 0.121246 36.6581 0.0940861 26.5373 0.0412852C16.9488 -0.00890827 15.7307 0.0225985 15.4239 0.329409ZM44.035 0.132763C43.6183 0.300944 43.7126 1.03299 44.1837 1.28504C44.4233 1.41324 46.1041 1.50993 48.0949 1.50993H51.5858V6.71723C51.5858 11.6431 51.6086 11.9367 52.006 12.1494C52.2624 12.2865 54.4664 12.3743 57.6555 12.3743H62.8848V39.4267V66.479H39.7436H16.6025V59.9782C16.6025 56.4027 16.5431 53.3226 16.4706 53.1336C16.2996 52.6879 15.3844 52.6879 15.2133 53.1336C15.1408 53.3226 15.0815 56.5913 15.0815 60.3971C15.0815 66.3984 15.1269 67.3625 15.4228 67.6586C15.7292 67.9648 18.2217 68 39.6089 68C58.343 68 63.5327 67.9418 63.8226 67.7284C64.1672 67.4748 64.1881 65.5542 64.1359 38.8895L64.0798 10.3223L58.3217 5.16124L52.5636 0L48.4351 0.0117337C46.1645 0.0180351 44.1845 0.0725741 44.035 0.132763ZM57.7857 6.53406C60.3512 8.81928 62.4502 10.726 62.4502 10.7712C62.4502 10.8164 60.299 10.8533 57.6699 10.8533H52.8895V6.6162C52.8895 4.28578 52.9417 2.37908 53.0053 2.37908C53.0692 2.37908 55.2204 4.24885 57.7857 6.53406Z"
          fill="#EDEDED"
        />
        <rect x="43.1119" y="28.0305" width="15.2101" height="15.2101" rx="5" fill="#EDEDED" />
        <rect x="4" y="17.165" width="36.7216" height="36.7216" rx="10" fill="#EDEDED" />
        <path
          d="M12.5132 29.5515C13.5217 29.5515 14.3397 29.8765 14.9674 30.5267C15.6003 31.1711 15.9167 32.0038 15.9167 33.0246C15.9167 34.0569 15.5977 34.8924 14.9597 35.5311C14.3217 36.1699 13.4805 36.4893 12.4361 36.4893H10.4295V41.5023H8.34576V29.5515H12.5132ZM11.9962 34.6842C12.5518 34.6842 12.984 34.5445 13.2927 34.2651C13.6066 33.9799 13.7635 33.5607 13.7635 33.0075C13.7635 31.9068 13.1255 31.3565 11.8495 31.3565H10.4295V34.6842H11.9962Z"
          fill="white"
        />
        <path
          d="M22.0907 29.5515C23.2123 29.5515 24.2105 29.8052 25.0851 30.3128C25.9598 30.8204 26.6389 31.5333 27.1226 32.4515C27.6062 33.3697 27.848 34.4019 27.848 35.5483C27.848 36.7174 27.6036 37.7554 27.1148 38.6621C26.6312 39.5632 25.9418 40.2619 25.0465 40.758C24.1513 41.2542 23.1249 41.5023 21.9672 41.5023H17.5759V29.5515H22.0907ZM21.8746 39.6973C23.0271 39.6973 23.9506 39.3151 24.6452 38.5509C25.3449 37.781 25.6948 36.7744 25.6948 35.5311C25.6948 34.2422 25.3424 33.2242 24.6375 32.4771C23.9378 31.73 22.9937 31.3565 21.8052 31.3565H19.6597V39.6973H21.8746Z"
          fill="white"
        />
        <path
          d="M36.3759 29.5515V31.3565H31.8843V34.4447H36.3759V36.2668H31.8843V41.5023H29.8005V29.5515H36.3759Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4287_64304"
          x="0"
          y="0"
          width="68.1574"
          height="76"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4287_64304" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4287_64304" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

const MemoPdfTemplateIcon = React.memo(PdfTemplateIcon);
export default MemoPdfTemplateIcon;
